import React from 'react'
import { EditOutlined } from '@ant-design/icons'
import Button from 'components/shared/Button'

const CreateCollageButton = ({
  collageUrl,
  text = 'Lag Collage',
}) => {
  if (!collageUrl) {
    return null
  }

  const collageUrlWithReferer = collageUrl.replace('_referer_', encodeURIComponent(window.location.href))
  return (
    <Button
      className="create-collage-button"
      icon={<EditOutlined />}
      onClick={() => {
        window.open(collageUrlWithReferer)
      }}
    >
      {text}
    </Button>
  )
}

export default CreateCollageButton
